import { useState } from 'react';
import { Menu, X } from 'lucide-react';

const navItems = [
  { label: 'Hizmetler', href: '#hizmetler' },
  
  { label: 'Hakkımızda', href: '#hakkimizda' },
  { label: 'İletişim', href: '#iletisim' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-md border-b border-border">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-5 py-4">
        <a href="#" className="flex flex-col">
          <span className="font-heading text-xl md:text-2xl font-semibold tracking-wide text-foreground">
            Gamze Nails & Lashes
          </span>
          <span className="w-full h-px bg-gold" />
        </a>

        <ul className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className="font-body text-sm tracking-wide text-muted-foreground hover:text-foreground transition-colors"
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4">
          <a
            href="#randevu"
            className="hidden md:inline-flex items-center px-5 py-2.5 rounded-full bg-blush text-foreground text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Randevu Al
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="md:hidden p-2"
            aria-label="Menü"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background border-t border-border px-5 pb-6 pt-2">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-base text-foreground border-b border-border/50"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#randevu"
            onClick={() => setOpen(false)}
            className="mt-4 block text-center py-3 rounded-full bg-blush text-foreground font-medium"
          >
            Randevu Al
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
